import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import AuthHelper from "./auth-helper";

const Auth0ProviderWithHistory = (props: React.PropsWithChildren) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const connection = process.env.REACT_APP_AUTH0_CONNECTION;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const defaultScopes = ["openid", "profile", "email", "offline_access"];
  const apiScopes = audience ? ["full_access"] : [];

  // Initialize Auth0
  const navigate = useNavigate();

  //TODO: Replace any
  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || "/");
  };

  return (
    <Auth0Provider
      domain={domain!}
      clientId={clientId!}
      authorizationParams={{
        ...(audience ? { audience } : {}),
        scope: [...defaultScopes, ...apiScopes].join(" "),
        connection: connection,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      legacySameSiteCookie={false}
    >
      <AuthHelper>{props.children}</AuthHelper>
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
